<ac-form-group *ngIf="treeMode" titleText="Attachments">
    <entities-tree-details [list]="treeDetailsList"></entities-tree-details>

    <ac-drop-down (openStatusChanged)="onTopologyDropDownOpen($event)">

        <a class="ac-dropdown-toggle" parent>View</a>
        <div class="qoe-dropdown" tooltip>
            <topology-tree-select #topologyTreeSelect
                                  (selectEntityChange)="qoeOnCheckFn($event)"
                                  [entitiesNamesList]="['tenants', 'regions', 'devices', 'links', 'sites']"
                                  [initialTopologySelection]="checkedItemsObject"
                                  [filterTreeEntitiesCallback]="filterTreeEntitiesCallback"
                                  [ngDisabled]="isMonitor"
                                  [searchBarPadding]="true"
                                  [tenantId]="additionalSettings.tenantId || model.tenantId">
            </topology-tree-select>
        </div>
    </ac-drop-down>
</ac-form-group>

<div *ngIf="!treeMode && (type === 'threshold' || type === 'alarmRule')">
    <ac-input-container [label]="linkOrCustomerProvider + ':'">
        <ac-select [(acModel)]="model.attachedLinks"
                   [items]="linksList"
                   [attr.alternativeName]="type + '.attachedLinks'"
                   [multiple]="true"
                   bindLabel="name"
                   bindValue="id">
        </ac-select>
    </ac-input-container>

    <ac-input-container [label]="deviceOrCustomerTeams + ':'">
        <ac-select [(acModel)]="model.attachedDevices"
                   [items]="devicesList"
                   [attr.alternativeName]="type + '.attachedDevices'"
                   [multiple]="true"
                   bindLabel="name"
                   bindValue="id">
        </ac-select>
    </ac-input-container>
</div>


